<template>
  <v-container fluid class="ActivateAlerts-mainContainer"> <!-- uso de clases css class="componente-nombreClase"-->
   <v-row>
      <v-col cols="12">
        Hola mundo
      </v-col>
    </v-row>    
  </v-container>
</template>

<script>

export default {
  name: 'ActivateAlerts',
    data () {
      return {
      }
  },
  components: {
  },
  computed: {
  },
  methods: {
  },
  mounted () {
  }
};
</script>

<style lang="css">
  @import '../style/ActivateAlerts.css';
</style>